let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("qs2fs")).then(() => parcelRequire('eZgS9'));